import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { BsArrowLeft, BsEnvelope } from "react-icons/bs";
import { getBaseUrl } from "../../service/apiUrl";
// import Logo from "../assets/logo-resizr.png"; // Make sure path is correct
// import "./ForgetPasswordNew.css";

const ForgetPassword = ({ data }) => {
  const [email, setEmail] = useState("");
  const history = useNavigate();
  const { t } = useTranslation();

  const [currentUrl, setCurrentUrl] = useState("");
  const [statusData, setstatusData] = useState(false);

  useEffect(() => {
    setCurrentUrl(window.location.origin);
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    setstatusData(true);
    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("ClientUrl", currentUrl);
      const res = await axios.post(
        `${
          getBaseUrl()
        }/password/forgot`,
        formData,
      );
      const msg = res.data.message;
      toast(msg);
      setstatusData(false);
      data();
    } catch (error) {
      const err = error.response.data.message;
      toast(err);
      setstatusData(false);
    }
  };

  return (
    <div className="new-fp-wrapper">
      {/* Header Section */}
      <div className="new-fp-header">
        <div className="new-fp-header-left">
          <button className="new-fp-back-btn" onClick={() => data()}>
            <BsArrowLeft />
          </button>
          <div className="new-fp-title-box">
            <h3>{t("Forgot Password")}</h3>
            <p>{t("Reset your account password")}</p>
          </div>
        </div>
        <div className="new-fp-header-right">
          {/* <img src={Logo} alt="Saddle Battle" className="new-fp-logo" /> */}
        </div>
      </div>

      {/* Body Section */}
      <div className="new-fp-body">
        <div className="new-fp-icon-container">
          <div className="new-fp-icon-circle">
            <BsEnvelope className="new-fp-mail-icon" />
          </div>
        </div>

        <p className="new-fp-instruction">
          {t(
            "Enter your email address and we'll send you a link to reset your password.",
          )}
        </p>

        <form onSubmit={submit} className="new-fp-form">
          <div className="new-fp-input-group">
            <label>{t("Email")}</label>
            <input
              required
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              name="Email"
              type="email"
              placeholder={t("Enter your email address")}
              className="new-fp-input"
            />
          </div>

          <button
            type="submit"
            disabled={statusData}
            className="new-fp-submit-btn"
          >
            {statusData ? t("Sending...") : t("Send Reset Link")}
          </button>
        </form>

        <div className="new-fp-footer">
          <span>{t("Remember your password?")} </span>
          <button className="new-fp-login-link" onClick={() => data()}>
            {t("Back to Login")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
